import * as React from "react";
import "../../../assets/scss/components/login/generic/loginPopup.scss";

export interface ILoginPopupProps {
	className?: string; // extra classname if required
	leftHeaderContent?: React.ReactChild; // text/element to show on the left side in the header
	centerHeaderContent?: React.ReactChild; // text/element to show in center in the header
	overlayClass?: React.CSSProperties; // style object for popup
	hideVersion?: boolean; // if this is true, then don't show version number
	onClose?: () => void; // if this function is present, then only show cross icon
}

const LoginPopup: React.FC<ILoginPopupProps> = props => {
	return (
		<div className={"login_overlay " + (props.overlayClass || "")}>
			<div className={"login_ppup " + (props.className || "")}>
				{/* Header */}
				<header>
					<div className="hdr_left">{props.leftHeaderContent}</div>
					<div className="hdr_center">{props.centerHeaderContent}</div>
					<div className="hdr_right">
						{props.onClose && (
							<button className="close" onClick={props.onClose}>
								<i className="edel-icon-close" />
							</button>
						)}
					</div>
				</header>

				{/* Main content */}
				{props.children}

				{/* Version number */}
				{!props.hideVersion && <div className="version">Nuvamawealth.com(TOC) Ver. 1.0.0.5</div>}
			</div>
		</div>
	);
};

export default LoginPopup;
